import { render, staticRenderFns } from "./ImpactCard.vue?vue&type=template&id=ff18444c&scoped=true&"
import script from "./ImpactCard.vue?vue&type=script&lang=js&"
export * from "./ImpactCard.vue?vue&type=script&lang=js&"
import style0 from "./ImpactCard.vue?vue&type=style&index=0&id=ff18444c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff18444c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VProgressCircular})
